module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "doctor"
  }, [_c('div', {
    staticClass: "app-sidebar",
    class: {
      hide: !_vm.visible, open: _vm.visible
    }
  }, [_c('app-sidebar', {
    on: {
      "toggleSidebar": _vm.toggle
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "movil-close-zone",
    class: {
      open: _vm.visible
    },
    on: {
      "click": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-main",
    class: {
      navOpen: _vm.visible
    }
  }, [_c('app-navbar', {
    on: {
      "toggleSidebar": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('router-view', {
    attrs: {
      "sidevisible": _vm.visible
    },
    on: {
      "toggleSidebar": _vm.toggle
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d20ebf0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/partials/Layout.vue
// module id = 685
// module chunks = 1